module.exports = __webpack_public_path__ + "media/images/icon-unlink-e7fb07addebb669e1f3ef03743dd8ae1.svg";